import type { CustomColours } from "@/plugins/vuetify";

/* START OF VUE 3 //
import { createVuetify } from "vuetify";
// END OF VUE 3 */

// START OF VUE 2 //
import Vue from "vue";
import Vuetify, {
  VAlert,
  VApp,
  VAppBar,
  VAppBarNavIcon,
  VAutocomplete,
  VAvatar,
  VBadge,
  VBottomSheet,
  VBtn,
  VCalendar,
  VCard,
  VCardActions,
  VCardText,
  VCardTitle,
  VCarousel,
  VCarouselItem,
  VCheckbox,
  VChip,
  VCol,
  VColorPicker,
  VCombobox,
  VContainer,
  VDatePicker,
  VDialog,
  VDivider,
  VExpandTransition,
  VExpandXTransition,
  VExpansionPanel,
  VExpansionPanelContent,
  VExpansionPanelHeader,
  VExpansionPanels,
  VFileInput,
  VFlex,
  VFooter,
  VForm,
  VIcon,
  VImg,
  VItem,
  VItemGroup,
  VLabel,
  VLayout,
  VList,
  VListGroup,
  VListItem,
  VListItemAction,
  VListItemContent,
  VListItemGroup,
  VListItemIcon,
  VListItemSubtitle,
  VListItemTitle,
  VMain,
  VMenu,
  VNavigationDrawer,
  VProgressCircular,
  VProgressLinear,
  VRadio,
  VRadioGroup,
  VRow,
  VScrollXTransition,
  VSelect,
  VSheet,
  VSkeletonLoader,
  VSlider,
  VSlideXTransition,
  VSlideYTransition,
  VSnackbar,
  VSpacer,
  VSpeedDial,
  VStepper,
  VStepperHeader,
  VStepperContent,
  VStepperItems,
  VStepperStep,
  VSwitch,
  VTab,
  VTabs,
  VTabsSlider,
  VTextarea,
  VTextField,
  VTimePicker,
  VTimeline,
  VTimelineItem,
  VToolbar,
  VToolbarTitle,
  VTooltip,
  VWindow,
  VWindowItem,
  VVirtualScroll,
} from "vuetify/lib";
import { Intersect } from "vuetify/lib/directives";
// END OF VUE 2 //

// START OF VUE 2 //
Vue.use(Vuetify, {
  components: {
    VAlert,
    VApp,
    VAppBar,
    VAppBarNavIcon,
    VAutocomplete,
    VAvatar,
    VBadge,
    VBottomSheet,
    VBtn,
    VCalendar,
    VCard,
    VCardActions,
    VCardText,
    VCardTitle,
    VCarousel,
    VCarouselItem,
    VCheckbox,
    VChip,
    VCol,
    VColorPicker,
    VCombobox,
    VContainer,
    VDatePicker,
    VDialog,
    VDivider,
    VExpandTransition,
    VExpandXTransition,
    VExpansionPanel,
    VExpansionPanelContent,
    VExpansionPanelHeader,
    VExpansionPanels,
    VFileInput,
    VFlex,
    VForm,
    VFooter,
    VIcon,
    VImg,
    VItem,
    VItemGroup,
    VLabel,
    VLayout,
    VList,
    VListGroup,
    VListItem,
    VListItemAction,
    VListItemContent,
    VListItemGroup,
    VListItemIcon,
    VListItemSubtitle,
    VListItemTitle,
    VMain,
    VMenu,
    VNavigationDrawer,
    VProgressCircular,
    VProgressLinear,
    VRadio,
    VRadioGroup,
    VRow,
    VScrollXTransition,
    VSelect,
    VSpeedDial,
    VSheet,
    VSkeletonLoader,
    VSlider,
    VSlideXTransition,
    VSlideYTransition,
    VSnackbar,
    VSpacer,
    VSwitch,
    VStepper,
    VStepperHeader,
    VStepperContent,
    VStepperItems,
    VStepperStep,
    VTab,
    VTabs,
    VTabsSlider,
    VTextField,
    VTextarea,
    VTimePicker,
    VTimeline,
    VTimelineItem,
    VToolbar,
    VToolbarTitle,
    VTooltip,
    VWindow,
    VWindowItem,
    VVirtualScroll,
  },
  directives: {
    Intersect,
  },
});

export const createVuetifyWrap = (
  lightColours: CustomColours,
  darkColours: CustomColours
) => {
  return new Vuetify({
    icons: {
      iconfont: "md",
    },
    theme: {
      themes: {
        light: {
          ...lightColours,
        },
        dark: {
          ...darkColours,
        },
      },
    },
  });
};

// END OF VUE 2 //

/* START OF VUE 3 //

export const createVuetifyWrap = (
  lightColours: CustomColours,
  darkColours: CustomColours
) => {
  return createVuetify({
    theme: {
      defaultTheme: "dark",
      themes: {
        light: {
          colors: {
            ...lightColours,
          },
        },
        dark: {
          colors: {
            ...darkColours,
          },
        },
      },
    },
  });
};

// END OF VUE 3 */
